const IngredientCategories = [
    {name: "spirit", localization: "Spirit", header: "Spirits"},
    {name: "liqueur", localization: "Liqueur", header: "Liqueurs"},
    {name: "bitters", localization: "Bitters", header: "Bitters"},
    {name: "mixer", localization: "Mixer", header: "Mixers"},
    {name: "syrup", localization: "Syrup", header: "Syrups"},
    {name: "wine", localization: "Wine", header: "Wines"},
    {name: "misc", localization: "Misc.", header: "Misc."}
];

export default IngredientCategories;